import React, { useEffect, useState } from "react";
import AdminPanelGeneralHeading from "../components/AdminPanelGeneralHeading";
import ErrorAlert from "../components/ErrorAlert";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "../components/SuccessAlert";

export default function UpdateHotel() {
  const { hotelId } = useParams();
  const navigate = useNavigate();

  // State Handling
  const [hotelsData, setHotelsData] = useState({
    hotel_img: "",
    hotel_name: "",
    hotel_location: "",
    hotel_city: "",
    hotel_country: "",
    hotel_complete_location: "",
    hotel_number: "",
    hotel_rating: "",
    hotel_rating_review: "",
    hotel_per_day_price: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [placesData, setPlacesData] = useState();
  const [loading, setLoading] = useState(false);

  // --------- Reading/Fetching Places From Database ---------
  const readingPlaces = async () => {
    const response = await fetch(
      "https://hotelbnb-backend.onrender.com/read-places"
    );
    const result = await response.json();

    if (!response.ok) {
      setSuccess("");
      setError("Places can't be fetched");
    } else if (response.ok) {
      setTimeout(() => {
        setError("");
      }, 10000);
      setPlacesData(result);
    }
  };

  // Upload Image Handling
  const hotelImgHandler = (e) => {
    const imgFile = e.target.files[0];
    if (imgFile) {
      const imgReader = new FileReader();
      imgReader.readAsDataURL(imgFile);
      imgReader.onloadend = () => {
        setHotelsData({
          ...hotelsData,
          hotel_img: imgReader.result,
        });
      };
      imgReader.onerror = (error) => {
        console.log(error);
      };
    }
  };

  //   Get Hotel's Data
  const singleHotel = async () => {
    const response = await fetch(
      `https://hotelbnb-backend.onrender.com/hotel/${hotelId}`
    );
    const result = await response.json();

    if (response.ok) {
      setHotelsData(result);
    }
  };

  // Form Submission To Update Hotel In DataBase
  const updateHotelsSubmitHandler = async (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    setLoading(true);

    try {
      const response = await fetch(
        `https://hotelbnb-backend.onrender.com/edit-hotel/${hotelId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(hotelsData),
        }
      );
      const result = await response.json();

      if (response.ok) {
        setSuccess("Hotel Updated!");

        setTimeout(() => {
          navigate("/admin/add-hotels");
        }, 1000);
      } else if (!response.ok) {
        setError("Update Failed! Please Try Again");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    singleHotel();
    readingPlaces();
  }, []);

  useEffect(() => {
    setHotelsData({
      ...hotelsData,
      hotel_complete_location: `${hotelsData.hotel_location}, ${hotelsData.hotel_city}, ${hotelsData.hotel_country}`,
    });
  }, [
    hotelsData.hotel_location,
    hotelsData.hotel_city,
    hotelsData.hotel_country,
  ]);

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Updating Hotel</p>
      </div>
    );

  if (!loading)
    return (
      <>
        {/* Showing Alert based on http request response Start */}
        {success && <SuccessAlert successMsg={success} />}
        {error && <ErrorAlert errorMsg={error} />}
        {/* Showing Alert based on http request response End */}

        {/*  Update Hotel Heading Start */}
        <AdminPanelGeneralHeading text="Update Hotel" />
        {/*  Update Hotel Heading End */}

        {/* Update Hotel Form Start */}
        <div className="col-12 add-places-form-cover signup-form-cover">
          <form
            method="post"
            className="p-0"
            onSubmit={updateHotelsSubmitHandler}
          >
            {/* Row 1 */}
            <div className="d-flex justify-content-center align-items-center">
              <div className="p-0 m-0 upload-place-hotel-pic-cover upload-profile-pic-cover d-flex justify-content-center align-items-center position-relative">
                <i className="fa-solid fa-camera"></i>
                <input
                  type="file"
                  name="hotel_img"
                  className="profile-pic-input"
                  onChange={hotelImgHandler}
                />
                {hotelsData.hotel_img ? (
                  <img
                    src={hotelsData.hotel_img}
                    alt="hotel-img"
                    className="img-fluid"
                  />
                ) : (
                  ""
                )}
              </div>
            </div>

            {/* Row 2 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="hotel_name"
                  placeholder="Hotel Name"
                  className="form-control text-capitalize"
                  required
                  value={hotelsData.hotel_name}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_name: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="hotel_location"
                  placeholder="Location w/o City & Country"
                  className="form-control text-capitalize"
                  required
                  value={hotelsData.hotel_location}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_location: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
            </div>

            {/* Row 3 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <select
                  name="hotel_city"
                  className="form-control text-capitalize"
                  required
                  value={hotelsData.hotel_city}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_city: e.target.value,
                    });
                  }}
                >
                  <option value="Select the city">Select the city</option>
                  {placesData?.map((optionVal) => {
                    return (
                      <option key={optionVal._id} value={optionVal.place_city}>
                        {optionVal.place_city}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col p-0 signup-col">
                <select
                  name="hotel_country"
                  className="form-control text-capitalize"
                  required
                  value={hotelsData.hotel_country}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_country: e.target.value,
                    });
                  }}
                >
                  <option value="Select the country">Select the country</option>
                  {placesData?.map((optionVal) => {
                    return (
                      <option
                        key={optionVal._id}
                        value={optionVal.place_country}
                      >
                        {optionVal.place_country}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            {/* Row 4 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <input
                  type="number"
                  name="hotel_number"
                  placeholder="Hotel Phone"
                  className="form-control"
                  required
                  value={hotelsData.hotel_number}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_number: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="hotel_rating"
                  placeholder="Hotel Rating (0-10)"
                  className="form-control text-capitalize"
                  required
                  value={hotelsData.hotel_rating}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_rating: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
            </div>

            {/* Row 5 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="hotel_rating_review"
                  placeholder="Rating Review"
                  className="form-control text-capitalize"
                  required
                  value={hotelsData.hotel_rating_review}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_rating_review: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="number"
                  name="hotel_per_day_price"
                  placeholder="Per Day Price"
                  className="form-control"
                  required
                  value={hotelsData.hotel_per_day_price}
                  onChange={(e) => {
                    setHotelsData({
                      ...hotelsData,
                      hotel_per_day_price: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
            </div>

            {/* Submit Btn */}
            <button
              type="submit"
              className="btn custom-btn signup-btn rounded-pill d-block mx-auto"
            >
              Update Hotel
            </button>
          </form>
        </div>
        {/* Update Hotel Form End */}
      </>
    );
}
